module.exports = __webpack_public_path__ + "img/editPage_coupon_couponApply.32a0bf91.svg";